import { Modal as ModalModule } from 'common';
import React, { useContext } from 'react';

const { Modal, ModalButtonActionType, ModalContext } = ModalModule;

const ConfirmDeleteModal = props => {
	const {
		modalId,
		data: { selectedUsers },
	} = props;
	const { closeModal } = useContext(ModalContext);

	const handleDelete = () => {
		const {
			data: { handleDeleteUser },
		} = props;

		if (handleDeleteUser) {
			handleDeleteUser();
		}

		closeModal(modalId);
	};

	const closeButton = {
		type: ModalButtonActionType.Cancel,
		text: 'Cancel',
		dataqa: 'confirm-delete-user-cancel-button',
	};
	const deleteButton = {
		type: ModalButtonActionType.Confirm,
		text: 'Delete',
		onClick: handleDelete,
		dataqa: 'confirm-delete-user-delete-button',
	};
	const message =
		selectedUsers &&
		(selectedUsers.length === 1
			? `Delete user ${selectedUsers[0].FirstName} ${selectedUsers[0].LastName}?`
			: `Delete ${selectedUsers.length} users?`);

	const header = `Delete ${selectedUsers && selectedUsers.length === 1 ? 'User' : 'Users'}`;

	return (
		<Modal
			modalId={modalId}
			header={header}
			primaryButton={deleteButton}
			secondaryButton={closeButton}
			size="small"
		>
			<p>{message}</p>
		</Modal>
	);
};

export default ConfirmDeleteModal;
